import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter } from 'lucide-react';
export function Footer() {
  return <footer className="bg-forest text-cream py-16" data-id="element-111">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-112">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12" data-id="element-113">
          <div className="col-span-1 md:col-span-2" data-id="element-114">
            <Link to="/" className="font-serif font-bold text-2xl tracking-wider mb-6 block" data-id="element-115">
              CRESTWOOD HOMES
            </Link>
            <p className="text-cream/80 max-w-md mb-8" data-id="element-116">
              Building premium, thoughtfully designed homes in the Pacific
              Northwest. We believe your home should be a true reflection of
              your lifestyle.
            </p>
            <div className="flex space-x-4" data-id="element-117">
              <a href="#" className="text-cream/80 hover:text-gold transition-colors" aria-label="Facebook" data-id="element-118">
                <Facebook size={20} data-id="element-119" />
              </a>
              <a href="#" className="text-cream/80 hover:text-gold transition-colors" aria-label="Instagram" data-id="element-120">
                <Instagram size={20} data-id="element-121" />
              </a>
              <a href="#" className="text-cream/80 hover:text-gold transition-colors" aria-label="Twitter" data-id="element-122">
                <Twitter size={20} data-id="element-123" />
              </a>
            </div>
          </div>

          <div data-id="element-124">
            <h3 className="font-serif text-lg font-semibold mb-6 text-gold" data-id="element-125">
              Quick Links
            </h3>
            <ul className="space-y-3" data-id="element-126">
              <li data-id="element-127">
                <a href="#communities" className="text-cream/80 hover:text-white transition-colors" data-id="element-128">
                  Communities
                </a>
              </li>
              <li data-id="element-129">
                <a href="#floor-plans" className="text-cream/80 hover:text-white transition-colors" data-id="element-130">
                  Floor Plans
                </a>
              </li>
              <li data-id="element-131">
                <a href="#about" className="text-cream/80 hover:text-white transition-colors" data-id="element-132">
                  About Us
                </a>
              </li>
              <li data-id="element-133">
                <Link to="/experience" className="text-cream/80 hover:text-white transition-colors" data-id="element-134">
                  Design Your Home
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-135">
            <h3 className="font-serif text-lg font-semibold mb-6 text-gold" data-id="element-136">
              Contact
            </h3>
            <ul className="space-y-3 text-cream/80" data-id="element-137">
              <li data-id="element-138">1234 Builder Way</li>
              <li data-id="element-139">Seattle, WA 98101</li>
              <li className="pt-2" data-id="element-140">
                <a href="tel:+15551234567" className="hover:text-white transition-colors" data-id="element-141">
                  (555) 123-4567
                </a>
              </li>
              <li data-id="element-142">
                <a href="mailto:hello@crestwoodhomes.com" className="hover:text-white transition-colors" data-id="element-143">
                  hello@crestwoodhomes.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-cream/20 flex flex-col md:flex-row justify-between items-center text-sm text-cream/60" data-id="element-144">
          <p data-id="element-145">
            &copy; {new Date().getFullYear()} Crestwood Homes. All rights
            reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-146">
            <a href="#" className="hover:text-cream transition-colors" data-id="element-147">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-cream transition-colors" data-id="element-148">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}